import React, { useState, createContext,useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Industries } from "./components/industries";
import { Eplatform } from "./components/eplatform";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Contact } from "./components/contact";
import DataITA from './data/dataITA.json';
import DataENG from './data/dataENG.json';


import SmoothScroll from "smooth-scroll";
 
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});
var cAgg="16.2.2026" //va rimesso in contacs
const LanguageContext = createContext();

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [language, setLanguage] = useState('italian');
  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
  };
  const data = language === 'italian' ? DataITA : DataENG;

  useEffect(() => {
    setLandingPageData(data); // Assuming JsonData is loaded asynchronously
  }, []);

  useEffect(() => {
    if (language === 'italian') {
      setLandingPageData(DataITA); 
    } else if (language === 'english') {
      setLandingPageData(DataENG); 
    }
  }, [language]); 
 
  return (
     
    <div>
       
      <Navigation data={landingPageData.Navigation} onLanguageChange={handleLanguageChange} ></Navigation> 
      <Header data={landingPageData.Header} />
      <Eplatform data={landingPageData.Eplatform} />
      <Industries data={landingPageData.Industries} />
      <Services data={landingPageData.Services} />
     
      <Contact data={landingPageData.Contact} />
    </div>
   
  );
};

export default App;
